package com.bulut.mecitogullari.core.session

import com.bulut.mecitogullari.core.i18n.Localization
import com.bulut.mecitogullari.data.model.User
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.FirebaseUser
import dev.gitlive.firebase.auth.auth
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

/**
 * App-wide session holder, backed by Firebase Auth. The session lives in
 * Firebase (Keychain / SharedPreferences / IndexedDB), so it survives app
 * restarts and reinstalls with the same Google account.
 */
object SessionManager {

    private val scope = CoroutineScope(SupervisorJob())

    private val _currentUser = MutableStateFlow<User?>(null)
    val currentUser: StateFlow<User?> = _currentUser.asStateFlow()

    val isLoggedIn: Boolean
        get() = _currentUser.value != null

    /** Call once at startup, after Firebase is initialized. */
    fun start() {
        _currentUser.value = Firebase.auth.currentUser?.toUser()
        scope.launch {
            Firebase.auth.authStateChanged.collect { firebaseUser ->
                _currentUser.value = firebaseUser?.toUser()
            }
        }
    }
}

fun FirebaseUser.toUser(): User = User(
    id = uid,
    name = when {
        isAnonymous -> Localization.strings.guestName
        else -> displayName
            ?: email?.substringBefore('@')
            ?: Localization.strings.defaultUserName
    },
    email = email ?: "",
    photoUrl = photoURL,
)
